var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-main-content" },
    [
      _c(
        "cargo-up-down-resize",
        {
          staticClass: "main-content",
          staticStyle: { height: "100%" },
          attrs: {
            "up-style": {
              display: "flex",
              flexDirection: "column",
              paddingBottom: "5px",
              height: "60%"
            },
            "down-style": {
              display: "flex",
              flexDirection: "column",
              paddingTop: "5px",
              height: "40%"
            }
          }
        },
        [
          _c("template", { slot: "up" }, [
            _c(
              "div",
              { staticClass: "section", staticStyle: { flex: "1" } },
              [
                _c(
                  "div",
                  { staticStyle: { "padding-bottom": "8px" } },
                  [
                    _c(
                      "el-form",
                      {
                        attrs: {
                          inline: true,
                          "label-width": "80px",
                          "label-position": "left"
                        }
                      },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { "label-width": "0" } },
                          [
                            _c(
                              "el-button",
                              {
                                attrs: { no: "1", type: "primary" },
                                on: {
                                  click: function($event) {
                                    return _vm.upSearchNoPallet()
                                  }
                                }
                              },
                              [_vm._v("查询")]
                            )
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          { attrs: { label: "货箱编号" } },
                          [
                            _c(
                              "el-select",
                              {
                                staticStyle: { width: "60px" },
                                attrs: { no: "4", placeholder: " " },
                                model: {
                                  value: _vm.up.containerNoOpt,
                                  callback: function($$v) {
                                    _vm.$set(_vm.up, "containerNoOpt", $$v)
                                  },
                                  expression: "up.containerNoOpt"
                                }
                              },
                              [
                                _c("el-option", {
                                  attrs: { label: "等于", value: "=" }
                                }),
                                _c("el-option", {
                                  attrs: { label: "不等于", value: "!=" }
                                }),
                                _c("el-option", {
                                  attrs: { label: "包含", value: "LIKE" }
                                })
                              ],
                              1
                            ),
                            _c("el-input", {
                              staticStyle: {
                                width: "150px",
                                "padding-left": "8px"
                              },
                              attrs: { no: "5" },
                              model: {
                                value: _vm.up.containerNo,
                                callback: function($$v) {
                                  _vm.$set(_vm.up, "containerNo", $$v)
                                },
                                expression: "up.containerNo"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          { attrs: { label: "中文品名" } },
                          [
                            _c(
                              "el-select",
                              {
                                staticStyle: { width: "60px" },
                                attrs: { no: "6", placeholder: " " },
                                model: {
                                  value: _vm.up.cargoNameOpt,
                                  callback: function($$v) {
                                    _vm.$set(_vm.up, "cargoNameOpt", $$v)
                                  },
                                  expression: "up.cargoNameOpt"
                                }
                              },
                              [
                                _c("el-option", {
                                  attrs: { label: "等于", value: "=" }
                                }),
                                _c("el-option", {
                                  attrs: { label: "不等于", value: "!=" }
                                }),
                                _c("el-option", {
                                  attrs: { label: "包含", value: "LIKE" }
                                })
                              ],
                              1
                            ),
                            _c("el-input", {
                              staticStyle: {
                                width: "150px",
                                "padding-left": "8px"
                              },
                              attrs: { no: "7" },
                              model: {
                                value: _vm.up.cargoName,
                                callback: function($$v) {
                                  _vm.$set(_vm.up, "cargoName", $$v)
                                },
                                expression: "up.cargoName"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          { attrs: { label: "Shipment ID" } },
                          [
                            _c(
                              "el-select",
                              {
                                staticStyle: { width: "60px" },
                                attrs: { no: "8", placeholder: " " },
                                model: {
                                  value: _vm.up.shipmentIdOpt,
                                  callback: function($$v) {
                                    _vm.$set(_vm.up, "shipmentIdOpt", $$v)
                                  },
                                  expression: "up.shipmentIdOpt"
                                }
                              },
                              [
                                _c("el-option", {
                                  attrs: { label: "等于", value: "=" }
                                }),
                                _c("el-option", {
                                  attrs: { label: "不等于", value: "!=" }
                                }),
                                _c("el-option", {
                                  attrs: { label: "包含", value: "LIKE" }
                                })
                              ],
                              1
                            ),
                            _c("el-input", {
                              staticStyle: {
                                width: "150px",
                                "padding-left": "8px"
                              },
                              attrs: { no: "9" },
                              model: {
                                value: _vm.up.shipmentId,
                                callback: function($$v) {
                                  _vm.$set(_vm.up, "shipmentId", $$v)
                                },
                                expression: "up.shipmentId"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          { attrs: { label: "Ref ID" } },
                          [
                            _c(
                              "el-select",
                              {
                                staticStyle: { width: "60px" },
                                attrs: { no: "8", placeholder: " " },
                                model: {
                                  value: _vm.up.referenceIdOpt,
                                  callback: function($$v) {
                                    _vm.$set(_vm.up, "referenceIdOpt", $$v)
                                  },
                                  expression: "up.referenceIdOpt"
                                }
                              },
                              [
                                _c("el-option", {
                                  attrs: { label: "等于", value: "=" }
                                }),
                                _c("el-option", {
                                  attrs: { label: "不等于", value: "!=" }
                                }),
                                _c("el-option", {
                                  attrs: { label: "包含", value: "LIKE" }
                                })
                              ],
                              1
                            ),
                            _c("el-input", {
                              staticStyle: {
                                width: "150px",
                                "padding-left": "8px"
                              },
                              attrs: { no: "9" },
                              model: {
                                value: _vm.up.referenceId,
                                callback: function($$v) {
                                  _vm.$set(_vm.up, "referenceId", $$v)
                                },
                                expression: "up.referenceId"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticStyle: { "padding-bottom": "8px" } },
                  [
                    _vm._v(
                      " 已选中 " +
                        _vm._s(_vm.up.selectedCount) +
                        " / " +
                        _vm._s(_vm.upAllCount) +
                        " "
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { disabled: !_vm.isEdit, no: "2" },
                        on: {
                          click: function($event) {
                            return _vm.upPick()
                          }
                        }
                      },
                      [_vm._v("拣选")]
                    ),
                    _c("el-input-number", {
                      staticStyle: { "padding-left": "8px" },
                      attrs: {
                        no: "3",
                        "controls-position": "right",
                        min: 0,
                        precision: 0
                      },
                      model: {
                        value: _vm.up.upQuantity,
                        callback: function($$v) {
                          _vm.$set(_vm.up, "upQuantity", $$v)
                        },
                        expression: "up.upQuantity"
                      }
                    }),
                    _vm._v("件 ")
                  ],
                  1
                ),
                _c("cargo-ag-grid", {
                  staticStyle: { width: "100%", flex: "1" },
                  attrs: {
                    no: "10",
                    "config-module": "140000",
                    "grid-options": _vm.gridOptions,
                    "grid-params": _vm.gridParams,
                    "column-defs": _vm.columnDefs,
                    "row-data": _vm.upRowData
                  },
                  on: {
                    "update:gridParams": function($event) {
                      _vm.gridParams = $event
                    },
                    "update:grid-params": function($event) {
                      _vm.gridParams = $event
                    },
                    gridReady: function(params) {
                      return (_vm.gridApi = params.api)
                    }
                  }
                })
              ],
              1
            ),
            _c("div", { staticStyle: { padding: "5px 0" } }, [
              _c(
                "div",
                { staticStyle: { float: "left" } },
                [
                  _c(
                    "el-button",
                    {
                      attrs: {
                        disabled: !_vm.isEdit,
                        no: "11",
                        type: "primary"
                      },
                      on: {
                        click: function($event) {
                          return _vm.addPallet()
                        }
                      }
                    },
                    [_vm._v("添加托盘")]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: {
                        disabled: !_vm.isEdit,
                        no: "12",
                        type: "danger"
                      },
                      on: {
                        click: function($event) {
                          return _vm.removePallet()
                        }
                      }
                    },
                    [_vm._v("删除托盘")]
                  ),
                  _c(
                    "el-button",
                    {
                      staticStyle: { color: "green" },
                      attrs: {
                        disabled: !_vm.isEdit,
                        no: "13",
                        type: "info",
                        plain: ""
                      },
                      on: {
                        click: function($event) {
                          return _vm.addToPalletHandler()
                        }
                      }
                    },
                    [_vm._v("↓")]
                  ),
                  _c(
                    "el-button",
                    {
                      staticStyle: { color: "red" },
                      attrs: {
                        disabled: !_vm.isEdit,
                        no: "14",
                        type: "info",
                        plain: ""
                      },
                      on: {
                        click: function($event) {
                          return _vm.removeToPalletHandler()
                        }
                      }
                    },
                    [_vm._v("↑")]
                  ),
                  _c(
                    "cargo-el-upload",
                    {
                      staticStyle: {
                        display: "inline-block",
                        "padding-left": "5px",
                        "padding-right": "5px"
                      },
                      attrs: {
                        no: "35",
                        disabled: _vm.isEdit,
                        action:
                          _vm.URL.booking.warehouseInDetail.importExcelPallet,
                        "show-file-list": false,
                        accept: ".xlsx",
                        "on-progress": _vm.handleProgress,
                        "on-success": _vm.handleSuccess,
                        "on-error": _vm.handleError,
                        data: {
                          branchId: _vm.$store.getters.currentOfficeId,
                          warehouseInUuid: _vm.warehouseIn.uuid
                        }
                      }
                    },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: {
                            disabled: _vm.isEdit,
                            no: "15",
                            type: "primary"
                          }
                        },
                        [_vm._v("EXCEL导入")]
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: {
                        disabled: _vm.isEdit,
                        no: "16",
                        type: "primary"
                      },
                      on: {
                        click: function($event) {
                          return _vm.downLoad()
                        }
                      }
                    },
                    [_vm._v("导入模板下载")]
                  )
                ],
                1
              ),
              _c(
                "div",
                { staticStyle: { float: "right" } },
                [
                  _c(
                    "el-form",
                    {
                      attrs: {
                        inline: true,
                        "label-width": "55px",
                        "label-position": "left"
                      }
                    },
                    [
                      _c(
                        "el-form-item",
                        {
                          staticClass: "custom",
                          attrs: { label: _vm.totalLabel.package }
                        },
                        [
                          _c("el-input", {
                            staticStyle: { width: "100px" },
                            attrs: { no: "17" },
                            model: {
                              value: _vm.up.totalQuantity,
                              callback: function($$v) {
                                _vm.$set(_vm.up, "totalQuantity", $$v)
                              },
                              expression: "up.totalQuantity"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          staticClass: "custom",
                          attrs: { label: _vm.totalLabel.weight }
                        },
                        [
                          _c("el-input", {
                            staticStyle: { width: "100px" },
                            attrs: { no: "18" },
                            model: {
                              value: _vm.up.totalWeight,
                              callback: function($$v) {
                                _vm.$set(_vm.up, "totalWeight", $$v)
                              },
                              expression: "up.totalWeight"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          staticClass: "custom",
                          attrs: { label: _vm.totalLabel.cubage }
                        },
                        [
                          _c("el-input", {
                            staticStyle: { width: "100px" },
                            attrs: { no: "19" },
                            model: {
                              value: _vm.up.totalCubage,
                              callback: function($$v) {
                                _vm.$set(_vm.up, "totalCubage", $$v)
                              },
                              expression: "up.totalCubage"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ])
          ]),
          _c(
            "template",
            { slot: "down" },
            [
              _c(
                "cargo-left-right-resize",
                {
                  staticStyle: { height: "100%", "min-height": "300px" },
                  attrs: {
                    "left-style": {
                      display: "flex",
                      flexDirection: "column",
                      width: "26%"
                    },
                    "right-style": {
                      display: "flex",
                      flexDirection: "column",
                      width: "74%"
                    }
                  }
                },
                [
                  _c("template", { slot: "left" }, [
                    _c(
                      "div",
                      { staticClass: "section", staticStyle: { flex: "1" } },
                      [
                        _c(
                          "div",
                          { staticStyle: { "padding-bottom": "8px" } },
                          [
                            _c(
                              "el-button",
                              {
                                staticStyle: { "margin-right": "8px" },
                                attrs: { no: "1", type: "primary" },
                                on: {
                                  click: function($event) {
                                    return _vm.downSearchPallet()
                                  }
                                }
                              },
                              [_vm._v("查询")]
                            ),
                            _c("el-input", {
                              staticStyle: { width: "200px" },
                              attrs: {
                                no: "20",
                                placeholder: "根据中文品名过滤托盘"
                              },
                              model: {
                                value: _vm.down.cargoName,
                                callback: function($$v) {
                                  _vm.$set(_vm.down, "cargoName", $$v)
                                },
                                expression: "down.cargoName"
                              }
                            })
                          ],
                          1
                        ),
                        _c("cargo-ag-grid", {
                          staticStyle: { height: "100%" },
                          attrs: {
                            no: "21",
                            "config-module": "140001",
                            "grid-options": _vm.left.gridOptions,
                            "grid-params": _vm.left.gridParams,
                            "column-defs": _vm.downLeftColumnDefs,
                            "row-data": _vm.downLeftRowData
                          },
                          on: {
                            "update:gridParams": function($event) {
                              return _vm.$set(_vm.left, "gridParams", $event)
                            },
                            "update:grid-params": function($event) {
                              return _vm.$set(_vm.left, "gridParams", $event)
                            },
                            gridReady: function(params) {
                              return (_vm.left.gridApi = params.api)
                            }
                          }
                        })
                      ],
                      1
                    )
                  ]),
                  _c("template", { slot: "right" }, [
                    _c(
                      "div",
                      { staticClass: "section", staticStyle: { flex: "1" } },
                      [
                        _c(
                          "div",
                          { staticStyle: { "padding-bottom": "8px" } },
                          [
                            _c(
                              "el-button",
                              {
                                staticStyle: { "padding-right": "15px" },
                                attrs: { no: "22", type: "primary" },
                                on: {
                                  click: function($event) {
                                    return _vm.downSearchCargoDetail()
                                  }
                                }
                              },
                              [_vm._v("查询")]
                            ),
                            _vm._v(" 货箱编号 "),
                            _c(
                              "el-select",
                              {
                                staticStyle: { width: "60px" },
                                attrs: { no: "23", placeholder: " " },
                                model: {
                                  value: _vm.down.containerNoOpt,
                                  callback: function($$v) {
                                    _vm.$set(_vm.down, "containerNoOpt", $$v)
                                  },
                                  expression: "down.containerNoOpt"
                                }
                              },
                              [
                                _c("el-option", {
                                  attrs: { label: "等于", value: "=" }
                                }),
                                _c("el-option", {
                                  attrs: { label: "不等于", value: "!=" }
                                }),
                                _c("el-option", {
                                  attrs: { label: "包含", value: "LIKE" }
                                })
                              ],
                              1
                            ),
                            _c("el-input", {
                              staticStyle: {
                                width: "200px",
                                "padding-left": "8px"
                              },
                              attrs: { no: "24" },
                              model: {
                                value: _vm.down.containerNo,
                                callback: function($$v) {
                                  _vm.$set(_vm.down, "containerNo", $$v)
                                },
                                expression: "down.containerNo"
                              }
                            })
                          ],
                          1
                        ),
                        _c("cargo-ag-grid", {
                          staticStyle: { "flex-grow": "1" },
                          attrs: {
                            no: "25",
                            "config-module": "140002",
                            "grid-options": _vm.right.gridOptions,
                            "grid-params": _vm.right.gridParams,
                            "column-defs": _vm.downRightColumnDefs,
                            "row-data": _vm.downRightRowData || []
                          },
                          on: {
                            "update:gridParams": function($event) {
                              return _vm.$set(_vm.right, "gridParams", $event)
                            },
                            "update:grid-params": function($event) {
                              return _vm.$set(_vm.right, "gridParams", $event)
                            },
                            gridReady: function(params) {
                              return (_vm.right.gridApi = params.api)
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c("div", { staticStyle: { padding: "5px 0" } }, [
                      _c("div", { staticStyle: { float: "left" } }, [
                        _vm._v(
                          " 已选中 " +
                            _vm._s(_vm.down.selectedCount) +
                            " / " +
                            _vm._s(_vm.downAllCount) +
                            " "
                        )
                      ]),
                      _c(
                        "div",
                        { staticStyle: { float: "right" } },
                        [
                          _c(
                            "el-form",
                            {
                              attrs: {
                                inline: true,
                                "label-width": "55px",
                                "label-position": "left"
                              }
                            },
                            [
                              _c(
                                "el-form-item",
                                {
                                  staticClass: "custom",
                                  attrs: { label: _vm.totalLabel.package }
                                },
                                [
                                  _c("el-input", {
                                    staticStyle: { width: "100px" },
                                    attrs: { no: "26" },
                                    model: {
                                      value: _vm.down.totalQuantity,
                                      callback: function($$v) {
                                        _vm.$set(_vm.down, "totalQuantity", $$v)
                                      },
                                      expression: "down.totalQuantity"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                {
                                  staticClass: "custom",
                                  attrs: { label: _vm.totalLabel.weight }
                                },
                                [
                                  _c("el-input", {
                                    staticStyle: { width: "100px" },
                                    attrs: { no: "27" },
                                    model: {
                                      value: _vm.down.totalWeight,
                                      callback: function($$v) {
                                        _vm.$set(_vm.down, "totalWeight", $$v)
                                      },
                                      expression: "down.totalWeight"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                {
                                  staticClass: "custom",
                                  attrs: { label: _vm.totalLabel.cubage }
                                },
                                [
                                  _c("el-input", {
                                    staticStyle: { width: "100px" },
                                    attrs: { no: "28" },
                                    model: {
                                      value: _vm.down.totalCubage,
                                      callback: function($$v) {
                                        _vm.$set(_vm.down, "totalCubage", $$v)
                                      },
                                      expression: "down.totalCubage"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ])
                  ])
                ],
                2
              )
            ],
            1
          )
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }